import styled from "styled-components";

export const Container = styled.div`
  margin: 0;
  padding: 20px;
  min-height: 100vh;
  background: #f8f9fa;

  @media (max-width: 768px) {
    padding: 16px;
    background: #ffffff;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
    align-items: stretch;
  }
`;

export const Title = styled.h2`
  color: #212529;
  font-weight: 700;
  font-size: 28px;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;

  @media (max-width: 768px) {
    font-size: 24px;
    justify-content: center;
  }
`;

export const TitleIcon = styled.div`
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, var(--primary), var(--primary-hover));
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;

  @media (max-width: 768px) {
    width: 36px;
    height: 36px;
  }
`;

export const SearchContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 400px;
  margin-bottom: 20px;
  display: none;

  @media (max-width: 768px) {
    display: inline-block;
    max-width: 100%;
  }
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 12px 16px 12px 48px;
  border: 2px solid #e9ecef;
  border-radius: 12px;
  font-size: 16px;
  background: white;
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: var(--primary);
    box-shadow: 0 0 0 3px rgba(40, 167, 69, 0.1);
  }

  &::placeholder {
    color: #6c757d;
  }
`;

export const SearchIcon = styled.div`
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: #6c757d;
`;

export const InfoCard = styled.div`
  background: linear-gradient(135deg, #e8f5e8, #f8f9fa);
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 20px;
  border-left: 4px solid var(--primary);

  p {
    margin: 0;
    color: #495057;
    font-size: 14px;
    line-height: 1.5;
  }
`;

export const StatsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 16px;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
  }
`;

export const StatCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  text-align: center;
  border: 2px solid transparent;
  transition: all 0.3s ease;

  &:hover {
    border-color: var(--primary);
    transform: translateY(-2px);
  }

  @media (max-width: 768px) {
    padding: 12px;
  }
`;

export const StatNumber = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: #212529;
  margin-bottom: 4px;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

export const StatLabel = styled.div`
  font-size: 12px;
  color: #6c757d;
  text-transform: uppercase;
  font-weight: 500;
`;

export const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  margin-bottom: 80px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 12px;
    margin-bottom: 100px;
  }
`;

export const TypeCard = styled.div`
  background: white;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  cursor: pointer;
  border: 2px solid transparent;
  position: relative;
  overflow: hidden;

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: ${(props) => props.color || "var(--primary)"};
  }

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);
    border-color: ${(props) => props.color || "var(--primary)"};
  }

  &:active {
    transform: translateY(-3px);
  }

  @media (max-width: 768px) {
    border-radius: 12px;
    padding: 16px;

    &:hover {
      transform: none;
    }

    &:active {
      background: #f8f9fa;
    }
  }
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
`;

export const TypeName = styled.h3`
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  color: #212529;
  line-height: 1.3;
  flex: 1;
  margin-right: 12px;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const StatusBadge = styled.span`
  display: inline-block;
  background: ${(props) => (props.active ? "var(--primary)" : "#6c757d")};
  color: white;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
  text-transform: uppercase;
`;

export const CardContent = styled.div`
  margin-bottom: 16px;
`;

export const DurationInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  color: #495057;
  font-size: 14px;
  font-weight: 500;
`;

export const ColorSample = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 6px;
  background: ${(props) => props.color || "var(--primary)"};
  border: 2px solid rgba(0, 0, 0, 0.1);
  display: inline-block;
  margin-right: 8px;
`;

export const Description = styled.p`
  color: #6c757d;
  font-size: 14px;
  line-height: 1.4;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CardFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 12px;
  border-top: 1px solid #e9ecef;
`;

export const ActionsContainer = styled.div`
  display: flex;
  gap: 8px;
`;

export const ActionButton = styled.button`
  background: ${(props) => {
    if (props.variant === "edit") return "#007bff";
    if (props.variant === "delete") return "#dc3545";
    if (props.variant === "toggle-on") return "var(--primary)";
    if (props.variant === "toggle-off") return "#6c757d";
    return "#6c757d";
  }};
  color: white;
  border: none;
  border-radius: 8px;
  padding: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    transform: scale(1.05);
    filter: brightness(1.1);
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const FloatingButton = styled.button`
  position: fixed;
  bottom: 24px;
  right: 24px;
  width: 56px;
  height: 56px;
  background: var(--primary);
  color: white;
  border: none;
  border-radius: 50%;
  font-size: 24px;
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: var(--primary-hover);
    transform: scale(1.05);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);
  }

  &:active {
    transform: scale(0.95);
  }

  @media (max-width: 768px) {
    bottom: 20px;
    right: 20px;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #6c757d;
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 60px 20px;
  color: #6c757d;
  background: white;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);

  h3 {
    color: #495057;
    margin-bottom: 8px;
    font-size: 24px;
    font-weight: 600;
  }

  p {
    margin-bottom: 24px;
    font-size: 16px;
    line-height: 1.5;
  }
`;

export const EmptyIcon = styled.div`
  font-size: 64px;
  margin-bottom: 16px;
  opacity: 0.6;
`;

// Modal Styled Components
export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 16px;
`;

export const Label = styled.label`
  font-weight: 600;
  color: #495057;
  font-size: 14px;
`;

export const Input = styled.input`
  padding: 12px 16px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 16px;
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: var(--primary);
    box-shadow: 0 0 0 3px rgba(40, 167, 69, 0.1);
  }

  &.is-invalid {
    border-color: #dc3545;
  }
`;

export const TextArea = styled.textarea`
  padding: 12px 16px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 16px;
  transition: all 0.3s ease;
  resize: vertical;
  min-height: 80px;

  &:focus {
    outline: none;
    border-color: var(--primary);
    box-shadow: 0 0 0 3px rgba(40, 167, 69, 0.1);
  }
`;

export const ColorInputContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const ColorButton = styled.button`
  background: white;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  padding: 8px 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    border-color: var(--primary);
  }
`;

export const ColorPickerContainer = styled.div`
  position: absolute;
  z-index: 1000;
  margin-top: 8px;
  right: 0;
  bottom: 175px;
`;

export const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
`;

export const CustomSwitch = styled.div`
  position: relative;
  width: 50px;
  height: 26px;
  background: ${(props) => (props.checked ? "var(--primary)" : "#dee2e6")};
  border-radius: 13px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:before {
    content: "";
    position: absolute;
    top: 2px;
    left: ${(props) => (props.checked ? "26px" : "2px")};
    width: 22px;
    height: 22px;
    background: white;
    border-radius: 50%;
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }
`;

export const ErrorMessage = styled.div`
  color: #dc3545;
  font-size: 12px;
  margin-top: 4px;
`;

export const HelpText = styled.div`
  color: #6c757d;
  font-size: 12px;
  margin-top: 4px;
`;
